import { useMutation, useQueryClient } from 'react-query'
import { AppEvents, QUERY_KEYS } from 'src/constants'

import { userService } from 'src/services/user.service'
import { EUserProviders } from 'src/types'

export const useRemoveUserProvider = (userId?: string) => {
  const queryClient = useQueryClient()

  return useMutation((provider: EUserProviders) => userService.removeUserProvider(provider), {
    onSuccess(data) {
      if (!data) return

      const detail = { message: data.message }

      const event = new CustomEvent(AppEvents.HTTP_SUCCESS, { detail })
      document.dispatchEvent(event)

      queryClient.invalidateQueries([QUERY_KEYS.USER_PROVIDERS])
    },
  })
}
